import React from 'react';

import SEO from '../components/SEO';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="min-h-screen bg-brand-light pt-32 pb-24 px-4 md:px-8">
            <SEO
                title="Gizlilik Politikası"
                description="Pato Yazılım Gizlilik Politikası ve Kişisel Verilerin Korunması Aydınlatma Metni."
                link="/gizlilik-politikasi"
                noIndex={true}
            />
            <div className="container mx-auto max-w-4xl bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
                    GİZLİLİK POLİTİKASI VE KİŞİSEL VERİLERİN KORUNMASI AYDINLATMA METNİ
                </h1>

                <div className="prose max-w-none text-gray-700">
                    <p className="font-medium text-gray-800">Son Güncelleme: 10.02.2026</p>

                    <p>
                        Ceren Tekin Bilgin - Pato Yazılım (“Pato Yazılım” veya “İşletme”) olarak, kişisel verilerinizin güvenliğine ve gizliliğine büyük önem veriyoruz. Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında kişisel verilerinizin hangi yöntemlerle toplandığı, hangi amaçlarla işlendiği, hukuki sebepleri, veri aktarımı süreçleri ve ilgili kişi haklarınız hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
                    </p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">1. VERİ SORUMLUSU</h2>
                    <p>KVKK uyarınca kişisel verileriniz; veri sorumlusu sıfatıyla Ceren Tekin Bilgin - Pato Yazılım tarafından işlenmektedir.</p>
                    <ul className="list-none pl-0 mt-2 space-y-1">
                        <li><strong>Unvan:</strong> Ceren Tekin Bilgin - Pato Yazılım</li>
                        <li><strong>Adres:</strong> Bozkurt Mah. Seymen Sk. No:43 D:3, 34375 Şişli / İstanbul</li>
                        <li><strong>E-posta:</strong> info@patoyazilim.com</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. HANGİ KİŞİSEL VERİLERİ TOPLUYORUZ?</h2>
                    <p>Aşağıda belirtilen kategorilerde kişisel veriler toplanmaktadır:</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">Kimlik Bilgileri</h3>
                    <p>Ad, soyad.</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">İletişim Bilgileri</h3>
                    <p>E-posta adresi, Telefon numarası.</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">Müşteri İşlem Bilgileri</h3>
                    <p>Web sitemizdeki iletişim formları aracılığıyla ilettiğiniz talepler, mesaj içerikleri, proje bilgileriniz.</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">İşlem Güvenliği Bilgileri</h3>
                    <ul className="list-disc pl-5">
                        <li>IP adresi</li>
                        <li>Tarayıcı bilgileri</li>
                        <li>Trafik kayıtları (5651 sayılı Kanun gereği)</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">Pazarlama ve Analiz Verileri</h3>
                    <ul className="list-disc pl-5">
                        <li>Çerezler aracılığıyla elde edilen kullanım bilgileri</li>
                        <li>Google Analytics vb. araçlardan elde edilen ziyaretçi istatistikleri</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. KİŞİSEL VERİLERİNİZİ HANGİ YÖNTEMLERLE TOPLUYORUZ?</h2>
                    <p>Kişisel verileriniz şu yöntemlerle toplanmaktadır:</p>
                    <ul className="list-disc pl-5">
                        <li>Web sitesi iletişim formları</li>
                        <li>E-posta yazışmaları</li>
                        <li>Sosyal medya hesapları</li>
                        <li>Çerezler ve benzeri teknolojiler</li>
                        <li>Otomatik ve otomatik olmayan yöntemlerle elektronik ortamlar</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. KİŞİSEL VERİLERİNİ İŞLEME AMAÇLARI VE HUKUKİ SEBEPLER</h2>
                    <p>Aşağıdaki amaçlarla kişisel verileriniz işlenmektedir:</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">A. Sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması (KVKK md. 5/2-c)</h3>
                    <ul className="list-disc pl-5">
                        <li>Hizmet ve yazılım projeleri hakkında teklif oluşturma</li>
                        <li>Tarafınıza dönüş yapılması ve iletişim kurulması</li>
                        <li>Proje süreçlerinin yürütülmesi</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">B. Hukuki yükümlülüğümüzü yerine getirmek (KVKK md. 5/2-ç)</h3>
                    <ul className="list-disc pl-5">
                        <li>5651 sayılı Kanun uyarınca trafik kayıtlarının saklanması</li>
                        <li>Vergi, ticaret ve diğer mevzuat gerekliliklerinin yerine getirilmesi</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">C. Bir hakkın tesisi, korunması veya kullanılması için zorunlu olması (KVKK md. 5/2-e)</h3>
                    <ul className="list-disc pl-5">
                        <li>Taleplerinizin değerlendirilmesi</li>
                        <li>Hukuki süreçlerin yürütülmesi</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">D. Meşru menfaatlerimiz doğrultusunda veri işleme (KVKK md. 5/2-f)</h3>
                    <ul className="list-disc pl-5">
                        <li>Hizmet kalitesinin artırılması</li>
                        <li>Sistem güvenliğinin sağlanması</li>
                        <li>Site kullanım analizlerinin yapılması</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">E. Açık rızanızın bulunması (KVKK md. 5/1)</h3>
                    <p>Aşağıdaki veriler yalnızca açık rızanızla işlenmektedir:</p>
                    <ul className="list-disc pl-5">
                        <li>Zorunlu olmayan analiz çerezleri</li>
                        <li>Pazarlama ve davranışsal reklam çerezleri</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. KİŞİSEL VERİLERİN AKTARILMASI</h2>
                    <p>Kişisel verileriniz kural olarak üçüncü kişilere aktarılmamaktadır. Ancak aşağıdaki durumlarda ve KVKK’nın 8 ve 9. maddelerine uygun olarak aktarım yapılabilir:</p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">A. Yurt İçi Aktarım</h3>
                    <ul className="list-disc pl-5">
                        <li>Hukuki zorunluluk halinde yetkili kamu kurumları (Mahkemeler, Savcılık vb.)</li>
                        <li>Hizmet aldığımız yerli iş ortakları ve teknik altyapı sağlayıcıları (örneğin e-posta sunucu hizmeti, güvenlik hizmeti sağlayıcılar)</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">B. Yurt Dışı Aktarım</h3>
                    <p>Analiz ve bulut tabanlı hizmetler (ör. Google Analytics, e-posta altyapısı vb.) kullanılması nedeniyle bazı kişisel verileriniz yurt dışına aktarılabilir. Bu aktarım:</p>
                    <ul className="list-disc pl-5">
                        <li>Açık rızanız ile veya</li>
                        <li>KVKK md.9 kapsamında Kurul kararlarına uygun şekilde gerçekleştirilir.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. VERİ SAKLAMA SÜRELERİ</h2>
                    <p>Kişisel verileriniz aşağıdaki süreler boyunca saklanır:</p>
                    <ul className="list-disc pl-5">
                        <li><strong>Trafik kayıtları:</strong> 5651 sayılı Kanun gereği en az 2 yıl</li>
                        <li><strong>Teklif ve müşteri ilişkilerine dair bilgiler:</strong> Sözleşme süresince + 10 yıl (zaman aşımı süresi)</li>
                        <li><strong>E-posta yazışmaları:</strong> 5 yıl</li>
                        <li><strong>Zorunlu çerezler:</strong> Oturum süresince</li>
                        <li><strong>Analiz çerezleri:</strong> Açık rızanız doğrultusunda, araç sağlayıcının belirlediği süre boyunca</li>
                    </ul>
                    <p className="mt-2">Süre dolduğunda veriler Kişisel Verileri Saklama ve İmha Politikamıza uygun şekilde silinir, yok edilir veya anonim hale getirilir.</p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">7. ÇEREZ (COOKIE) KULLANIMI</h2>
                    <p>Web sitemizde aşağıdaki çerez türleri kullanılmaktadır:</p>
                    <ul className="list-disc pl-5">
                        <li><strong>Zorunlu Çerezler:</strong> Sitenin çalışması için gereklidir. Açık rıza gerektirmez.</li>
                        <li><strong>Analiz ve Performans Çerezleri:</strong> (Trafik analizi, ziyaretçi davranışları vb.) Bu çerezler açık rızanıza tabidir ve çerez yönetim panelinden izin vermediğiniz sürece çalışmaz. Tarayıcı ayarlarını kullanarak çerezleri dilediğiniz zaman yönetebilir veya engelleyebilirsiniz.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">8. VERİ GÜVENLİĞİ ÖNLEMLERİ</h2>
                    <p>Kişisel verilerinizin güvenliği için İşletmemiz tarafından gerekli teknik ve idari tedbirler alınmaktadır:</p>
                    <ul className="list-disc pl-5">
                        <li>SSL sertifikası kullanımı</li>
                        <li>Güvenlik duvarı ve saldırı önleme sistemleri</li>
                        <li>Erişim kısıtlamaları</li>
                        <li>Veri yedekleme</li>
                        <li>Gizlilik taahhütleri</li>
                        <li>Düzenli güvenlik kontrolleri</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">9. İLGİLİ KİŞİNİN HAKLARI (KVKK MADDE 11)</h2>
                    <p>KVKK uyarınca aşağıdaki haklara sahipsiniz:</p>
                    <ul className="list-disc pl-5">
                        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                        <li>İşleme faaliyeti hakkında bilgi talep etme</li>
                        <li>İşlenme amacını ve uygun kullanılıp kullanılmadığını öğrenme</li>
                        <li>Yurt içi/yurt dışı aktarım yapılan üçüncü kişileri öğrenme</li>
                        <li>Eksik veya yanlış işlenmişse düzeltilmesini talep etme</li>
                        <li>Silinmesini veya yok edilmesini isteme</li>
                        <li>İşlemenin yalnızca otomatik sistemlerle analiz edilmesiyle aleyhe sonuç çıkmasına itiraz etme</li>
                        <li>Zarara uğramanız hâlinde tazminat talep etme</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">10. BAŞVURU YÖNTEMLERİ</h2>
                    <p>Haklarınıza ilişkin taleplerinizi KVKK Başvuru Tebliği’ne uygun şekilde aşağıdaki yöntemlerle iletebilirsiniz:</p>
                    <ul className="list-none pl-0 mt-2 space-y-1">
                        <li><strong>Yazılı olarak:</strong> Ceren Tekin Bilgin - Pato Yazılım, Bozkurt Mah. Seymen Sk. No:43 D:3, 34375 Şişli / İstanbul</li>
                        <li><strong>E-posta ile (sistemde kayıtlı e-posta adresinizden):</strong> info@patoyazilim.com</li>
                    </ul>
                    <p className="mt-4">Başvurularınız, KVKK md.13 uyarınca en geç 30 gün içinde sonuçlandırılacaktır.</p>
                </div>
            </div>
        </div>
    );
};


export default PrivacyPolicy;
